import {
  PRIMARY_KEY,
  convertRequestParams,
} from '@redux/crudCreator/dataProvider';
import { apiWrapper } from '@redux/crudCreator/reduxUtils';
import { GetAllPayloadType } from '@redux/crudCreator/types';
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getConfigApi,
  getSummariesApi,
  getRevenueApi,
  getGlobalSaleApi,
  getSummariesCustomersApi,
  getPopularProductApi,
  getAddressApi,
  clearCacheApi,
  getJobStatusApi,
  getChainStoresApi,
  getPartnerFiltersApi,
  getChannelSummaryApi,
  getSummaryOrderDeliveryApi,
  getTransferOrderStatusCountApi,
  getOrderStatusCountApi,
} from 'api/configs';
import { getAllApi } from 'api/crud';
// import api

// export const getAddress = createAsyncThunk(
//   'config/getAddress',
//   async (payload, thunkAPI) => {
//     try {
//       const response = await apiWrapper(null, getAddressApi);
//       return response;
//     } catch (error) {
//       return thunkAPI.rejectWithValue({ data: error });
//     }
//   },
// );
export const clearCache = createAsyncThunk(
  'config/clearCache',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async (payload: any, thunkAPI) => {
    try {
      const response = await apiWrapper(null, clearCacheApi, payload || {});
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue({ data: error });
    }
  },
);
export const clearAllCache = createAsyncThunk(
  'config/clearAllCache',
  async (payload, thunkAPI) => {
    try {
      const response = await Promise.all(
        ['config', 'product', 'cms', 'address', 'productDetail'].map((e) =>
          apiWrapper(null, clearCacheApi, {
            key: e,
          }),
        ),
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue({ data: error });
    }
  },
);

export const getConfig = createAsyncThunk(
  'config/getConfig',
  async (payload: GetAllPayloadType, thunkAPI) => {
    try {
      const { data = {} } = payload;
      const response = await apiWrapper(null, getConfigApi);
      try {
        const channelLocations = await apiWrapper(
          null,
          getAllApi,
          'locations',
          convertRequestParams('GET_ALL', {
            ...data,
          }),
        );
        response.channelLocations = channelLocations?.data || [];
      } catch (error) {
        //
      }
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue({ data: error });
    }
  },
);

export const getSummaries = createAsyncThunk(
  'config/getSummaries',
  async (payload, thunkAPI) => {
    try {
      const response = await apiWrapper(null, getSummariesApi);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue({ data: error });
    }
  },
);

export const getRevenue = createAsyncThunk(
  'config/getRevenue',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async (payload: any, thunkAPI) => {
    try {
      const response = await apiWrapper(null, getRevenueApi, payload);
      return { data: response, type: payload.type };
    } catch (error) {
      return thunkAPI.rejectWithValue({ data: error });
    }
  },
);

export const getGlobalSales = createAsyncThunk(
  'config/getGlobalSales',
  async (payload, thunkAPI) => {
    try {
      const response = await apiWrapper(null, getGlobalSaleApi);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue({ data: error });
    }
  },
);

export const getSummariesCustomers = createAsyncThunk(
  'config/getSummariesCustomers',
  async (payload, thunkAPI) => {
    try {
      const response = await apiWrapper(null, getSummariesCustomersApi);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue({ data: error });
    }
  },
);

export const getPopularProduct = createAsyncThunk(
  'config/getPopularProduct',
  async (payload, thunkAPI) => {
    try {
      const response = await apiWrapper(null, getPopularProductApi);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue({ data: error });
    }
  },
);

export const getJobStatus = createAsyncThunk(
  'locationStocks/getJobStatus',
  async (payload: GetAllPayloadType, thunkAPI) => {
    const { data } = payload;

    try {
      const response = await apiWrapper(
        null,
        getJobStatusApi,
        data[PRIMARY_KEY],
      );
      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue({ error: true, data: response });
    } catch (error) {
      return thunkAPI.rejectWithValue({ data: error, error: true });
    }
  },
);

export const getChainStores = createAsyncThunk(
  'config/getChainStores',
  async (payload: GetAllPayloadType, thunkAPI) => {
    try {
      const response = await apiWrapper(null, getChainStoresApi);

      if (response) {
        return response?.data || [];
      }
      return thunkAPI.rejectWithValue({ error: true, data: response });
    } catch (error) {
      return thunkAPI.rejectWithValue({ data: error, error: true });
    }
  },
);

export const getAddress = createAsyncThunk(
  'config/getAddress',
  async (payload, thunkAPI) => {
    try {
      const response = await apiWrapper(null, getAddressApi);
      // return response;
      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue({ error: true, data: response });
    } catch (error) {
      return thunkAPI.rejectWithValue({ data: error, error: true });
    }
  },
);

export const getConfigPartner = createAsyncThunk(
  'config/getConfigPartner',
  async (payload, thunkAPI) => {
    try {
      const partners = await apiWrapper(null, getPartnerFiltersApi);
      if (partners) {
        return { partners: partners?.data };
      }
      return thunkAPI.rejectWithValue({
        error: true,
        data: { partners: partners?.data },
      });
    } catch (error) {
      return thunkAPI.rejectWithValue({ data: error, error: true });
    }
  },
);

export const getChannelSummary = createAsyncThunk(
  'config/getChannelSummary',
  async (payload: any, thunkAPI) => {
    const { data } = payload;
    try {
      const response = await apiWrapper(null, getChannelSummaryApi, data);
      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue({ error: true, data: response });
    } catch (error) {
      return thunkAPI.rejectWithValue({ data: error, error: true });
    }
  },
);

export const getSummaryOrderDelivery = createAsyncThunk(
  'config/getSummaryOrderDelivery',
  async (payload: any, thunkAPI) => {
    const { data } = payload;
    try {
      const response = await apiWrapper(null, getSummaryOrderDeliveryApi, data);
      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue({ error: true, data: response });
    } catch (error) {
      return thunkAPI.rejectWithValue({ data: error });
    }
  },
);

export const getOrderStatusCount = createAsyncThunk(
  'config/getOrderStatusCount',
  async (payload: any, thunkAPI) => {
    const { data } = payload;
    try {
      const response = await apiWrapper(null, getOrderStatusCountApi, data);
      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue({ error: true, data: response });
    } catch (error) {
      return thunkAPI.rejectWithValue({ data: error });
    }
  },
);

export const getTransferOrderStatusCount = createAsyncThunk(
  'config/getTransferOrderStatusCount',
  async (payload: any, thunkAPI) => {
    const { data } = payload;
    try {
      const response = await apiWrapper(
        null,
        getTransferOrderStatusCountApi,
        data,
      );
      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue({ error: true, data: response });
    } catch (error) {
      return thunkAPI.rejectWithValue({ data: error });
    }
  },
);

export const getAllLocations = createAsyncThunk(
  'config/getAllLocations',
  async (payload: GetAllPayloadType, thunkAPI) => {
    try {
      const { data = {} } = payload;
      try {
        const channelLocations = await apiWrapper(
          null,
          getAllApi,
          'locations',
          convertRequestParams('GET_ALL', {
            ...data,
            limit: 99,
          }),
        );
        return channelLocations?.data || [];
      } catch (error) {
        //
      }
    } catch (error) {
      return thunkAPI.rejectWithValue({ data: error });
    }
  },
);
